// src/pages/EditPost/EditPostPage.jsx
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spin, message } from "antd";
import BlogLayout from "../../components/BlogLayout";
import PostForm from "../../components/PostForm";
import { usePost, useAuth } from "../../hooks/useBlogAPI";
import api from "../../api/blogAPI";
import "./EditPostPage.css";

const EditPostPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: post, loading } = usePost(id);

  const handleSubmit = async (values) => {
    try {
      await api.updatePost(id, values);
      message.success("文章更新成功！");
      navigate(`/posts/${id}`);
    } catch (error) {
      message.error("更新失败: " + error.message);
    }
  };

  const handleCancel = () => {
    navigate(`/posts/${id}`);
  };

  const handleCreatePost = () => {
    navigate("/posts/create");
  };

  return (
    <BlogLayout user={user} onCreatePost={handleCreatePost}>
      <div className="container">
        <Spin spinning={loading}>
          {post ? (
            <PostForm
              initialValues={post}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              mode="edit"
            />
          ) : null}
        </Spin>
      </div>
    </BlogLayout>
  );
};

export default EditPostPage;
